
export const banner = {
    url:"https://assets.licious.in/oms/be8c794c-56ba-acd9-fdd4-ab629109b316/original/1717760908086.jpeg",
    alt:"banner"
}

export const logo = {
     src:"https://www.licious.in/image/rebranding/svg/licious-logo.svg",
    alt:"nav_logo"
}

 export  const catheader = {
    src:'https://assets.licious.in/oms/8839eb27-ddc1-bdd7-2f01-eff5a3ee1eb5/original/1716532118557.png',
    alt:'chickenimage'
}